import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BE = process.env.REACT_APP_BACKEND_URL;
const resolveUrl = (u) => (u?.startsWith("http") ? u : `${BE}${u}`);
const SPANS = ["lg:col-span-6", "lg:col-span-3", "lg:col-span-3", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4", "lg:col-span-6", "lg:col-span-6"];

export const FeaturedWork = () => {
  const [album, setAlbum] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/albums/featured`).then(({ data }) => {
      if (data?.album && Array.isArray(data.items) && data.items.length > 0) {
        setAlbum(data.album); setItems(data.items.slice(0, 8));
      }
    }).catch(() => {});
  }, []);

  if (!album || items.length === 0) return null;

  return (
    <section className="section px-6 lg:px-10 border-t border-white/10" data-testid="featured-work">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
        <div className="lg:col-span-7">
          <div className="eyebrow mb-4">Featured Work</div>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tighter">
            From <span className="text-[#FF5722]">{album.title}</span>.
          </h2>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
          <Link to={`/gallery/${album.slug}`} className="btn-ghost" data-testid="featured-view-album">
            View Full Album <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
        {items.map((it, i) => (
          <Link
            key={it.id}
            to={`/gallery/${album.slug}`}
            className={`group relative overflow-hidden border border-white/10 ${SPANS[i % SPANS.length]} min-h-[220px] block`}
            data-testid={`featured-item-${i}`}
          >
            <img src={resolveUrl(it.image_url)} alt={it.title} className="w-full h-full object-cover absolute inset-0 opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <div className="relative p-5 h-full flex flex-col justify-end min-h-[220px]">
              <div className="text-[10px] uppercase tracking-widest text-[#FF5722]">{it.tag}</div>
              <div className="font-display text-xl md:text-2xl tracking-tight mt-1">{it.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
